export default __webpack_public_path__ + "static/media/README.73344428.md";